import { SearchIcon } from "./Icons";

interface SearchFormProps {
  value: string;
  loading: boolean;
  validationMessage?: string;
  requestError?: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  onUseExample: () => void;
}

export function SearchForm({
  value,
  loading,
  validationMessage,
  requestError,
  onChange,
  onSubmit,
  onUseExample,
}: SearchFormProps) {
  const error = validationMessage ?? requestError;

  return (
    <section className="search-card" aria-labelledby="search-title">
      <div className="mini-logo">
        <span className="mini-mark" aria-hidden="true">
          G
        </span>
        <div>
          <strong id="search-title">Consulta CNPJ</strong>
          <small>por GSEMP · dados públicos</small>
        </div>
      </div>

      <form
        onSubmit={(event) => {
          event.preventDefault();
          onSubmit();
        }}
        noValidate
      >
        <label htmlFor="cnpj">Digite o CNPJ da empresa</label>
        <div className="search-control">
          <input
            id="cnpj"
            name="cnpj"
            value={value}
            onChange={(event) => onChange(event.target.value)}
            inputMode="text"
            autoComplete="off"
            spellCheck={false}
            maxLength={18}
            placeholder="00.000.000/0000-00"
            aria-describedby={error ? "cnpj-error cnpj-help" : "cnpj-help"}
            aria-invalid={Boolean(validationMessage)}
          />
          <button type="submit" disabled={loading}>
            {loading ? (
              <>
                <span className="size-4 animate-spin rounded-full border-2 border-white/35 border-t-white" />
                Consultando
              </>
            ) : (
              <>
                <SearchIcon className="size-4" />
                Consultar
              </>
            )}
          </button>
        </div>

        {error ? (
          <p id="cnpj-error" role="alert" className="search-error">
            {error}
          </p>
        ) : null}

        <p id="cnpj-help" className="search-help">
          Aceita CNPJ numérico e o novo formato alfanumérico. Resultados ficam salvos nesta sessão por 30 minutos.
        </p>
        <button type="button" className="search-example" onClick={onUseExample}>
          Usar um CNPJ de exemplo
        </button>
      </form>
    </section>
  );
}
